// extracted by mini-css-extract-plugin
module.exports = {"textContent":"_3ZURSY8tvWkGkywC6ZYCXG","modalTitle":"_1hOKSM87abKBuPEQrVdPdd"};